﻿import $ from 'jquery';
import _ from 'underscore'

export class ItemList {
  public static wireupDocument: Function = _.once(() => {
    $(document).on('click.rustig.itemlist', '.il-item', function (e: JQueryEventObject): void {
      let $this = $(this);
      let $list = $this.closest('.itemlist');

      $list.find('.il-item.il-selected').removeClass('il-selected');
      $this.addClass('il-selected');
    });
  });
}
